import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

export interface MenuItemsInterface {
    id: string;
    title: string,
    status?: 'pending'| 'in_progress'|'completed';
    visible: boolean;
    selected?: boolean;
    items?: MenuItemsInterface[]
    groupId?: string;
    iconClass?: string;
}

export interface SidebarMetadataInterface {
    showProgressBar: boolean,
    groups?: any[]
    items: Array<MenuItemsInterface>
}
@Injectable({
  providedIn: 'root'
})
export class SidebarNavService {

    private triggerEvent = new Subject();
    triggerEvent$ = this.triggerEvent.asObservable();
    formChangeDetection: boolean = false;

    private _metaData: SidebarMetadataInterface = undefined;
    static CONSTANTS: Object = {
        'onCurrentActiveItem': 'EVENT.NAV.CURRENT.ACTIVE',
    }

    menuItems: Array<MenuItemsInterface> = undefined;
    _defaultSelectedId: string = undefined;
    _groups: any[] = [];
    _menuItemsByGroup: any = {};

    constructor() { }

    dispatchEvent(actionName:string, data:any={}) {
        data['actionName'] = actionName;
        this.triggerEvent.next(data);
    }

    setMetadata(data:SidebarMetadataInterface) {
        this._metaData = data;
        this.menuItems = data.items;
        if(data.hasOwnProperty('groups')) {
            this._groups = data.groups;
            this._menuItemsByGroup = data.items.reduce( (r, a) => {
                r[a.groupId] = r[a.groupId] || [];
                r[a.groupId].push(a);
                return r;
            }, {});
            console.log('group', this._menuItemsByGroup);
        }
    }

    get groups() {
        return this._groups;
    }

    get menuItemsGroup() {
        return this._menuItemsByGroup;
    }

    setDefaultSelectedId(id:string) {
        this._defaultSelectedId = id;
    }

    getMetadata() {
        return this._metaData;
    }

    showProgressBar() {
        return this._metaData.showProgressBar;
    }

    getMenuItems() {
        return this.menuItems;
    }

    setActiveGroupItem(groupId:any, itemId:any) {
        const groupItems = this._menuItemsByGroup[groupId];
        if(groupItems) {
            this.setActiveItem(itemId, groupItems);
        }
    }

    setActiveItem(id?: string, menuItems:any = undefined) {
        if(this._defaultSelectedId) {
            id = this._defaultSelectedId;
            this._defaultSelectedId=undefined;
        }
        let _item:MenuItemsInterface;
        const _menutItems = typeof menuItems != 'undefined' ? menuItems : this.menuItems;
        if(!id) {
            let lastIndex = this._findLastIndex('status', 'in_progress')
            if(lastIndex < 0) {
                lastIndex = this._findLastIndex('status', 'completed')
            }
            _item = _menutItems[lastIndex];
        }
        else {
            _item = _menutItems.find( item => item.id == id);
        }
        if(_item ) {
            this._resetSelected();
            _item.selected = true;
            const totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _item,
                totalProgress
            });
        }
    }

    goTo(currentId: string, nextAction:string) {
        let currentIndex = this.menuItems.findIndex( item => item.id == currentId),
            nextIndex:number,  _currentItem:MenuItemsInterface, _nextItem:MenuItemsInterface;
        if(nextAction === 'next') {
            nextIndex = currentIndex+1;
        }
        else if(nextAction === 'prev') {
            nextIndex = currentIndex-1;
        }
        if(this.menuItems[nextIndex]) {
            _currentItem = this.menuItems[currentIndex];
            _nextItem = this.menuItems[nextIndex];
        }
        if(_currentItem && _nextItem ) {
            this._resetSelected();
            if(_currentItem.status != 'completed' && nextAction === 'next') {
                _currentItem.status = 'completed';
                _nextItem.status = 'in_progress';
            }
            _nextItem.selected = true;
            const totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _nextItem,
                totalProgress
            });
        }
    }

    goToPrev(currentId: string) {
        this.goTo(currentId, 'prev');
    }

    goToNext(currentId: string) {
        this.goTo(currentId, 'next');
    }

    goToFinish(currentId: string) {
        let currentIndex = this.menuItems.findIndex( item => item.id == currentId);
        const _currentItem = this.menuItems[currentIndex];
        if(_currentItem ) {
            _currentItem.status = 'completed';
            const totalProgress = this._calculateProgress();
            this.dispatchEvent(SidebarNavService.CONSTANTS['onCurrentActiveItem'], {
                currentActiveItem: _currentItem,
                totalProgress
            });
        }
    }

    private _calculateProgress() {
        let totalCount = this.menuItems.length,
        completedCount = 0;
        this.menuItems.forEach( (item) => {
            if(item.status === 'completed') {
                completedCount += 1;
            }
        });
        const totalProgress = (completedCount / totalCount) * 100;
        return Math.round(totalProgress);
    }
    private _resetSelected() {
        this.menuItems.forEach( item => {
           item.selected = undefined;
        });
    }

    private _findLastIndex(searchKey, searchValue) {
        const index = this.menuItems.slice().reverse().findIndex(x => x[searchKey] === searchValue);
        const count = this.menuItems.length - 1;
        // console.log(finalIndex)
        return index >= 0 ? count - index : index;
    }
}
